<div class="container">
  <div class="inner"
    [class.private]="contactToDisplay?.ContactTypeId === ContactHelper.CONTACT_TYPE_PRIVATE"
    [class.trade]="contactToDisplay?.ContactTypeId === ContactHelper.CONTACT_TYPE_TRADE"
    [class.planer]="contactToDisplay?.ContactTypeId === ContactHelper.CONTACT_TYPE_PLANER">
    <div class="name-row">
      @if (!contactToDisplay?.Anonymized) {
        <div class="main-title"
          >{{ contactToDisplay?.Title }} {{ contactToDisplay?.FirstName }} {{ contactToDisplay?.LastName }}
        </div>
      }
      @if (contactToDisplay?.Anonymized) {
        <div class="main-title"
        fiTranslation="REQUEST_DETAIL_HEADLINE_CONTACT_ANONYMIZE"></div>
      }
      @if (contactToDisplay?.Inactive) {
        <span class="inactive-badge" fiTranslation="REQUEST_CREATE_CONTACT_BADGE_INACTIVE"></span>
      }

      @if (canEditContact) {
        <button (click)="editIconClick()">
          <img src="assets/icons/pencil.svg" alt="Edit" #edit [isTitle]="true"
            fiTranslation="ALT_TEXT_REQUEST_LIST_EDIT" matTooltip="{{edit.dataset.matTooltip}}"
            matTooltipPosition="below" matTooltipClass='tooltip-style'>
          </button>
        }
      </div>
      <div class="type-row">
        {{ contactToDisplay?.ContactTypeText }}
      </div>

      @if (!contactToDisplay?.Anonymized && contactToDisplay?.Company) {
        <div class="company-row">
          {{ contactToDisplay?.Company }} <br>
          {{ contactToDisplay?.JobTitle }}
        </div>
      }

      <div class="show-on-mobile">
        <div class="mobile-row">
          @if (contactMobile && !(contactPhone && contactToDisplay?.ContactMethodName === 'TELEFON')) {
            <a
              [class.preffered]="contactToDisplay?.ContactMethodName === 'MOBILE'"
              href="tel: {{ contactMobile }}"
              >
              <img alt="email" src="assets/icons/mobile-phone.svg">
            </a>
          }

          @if (contactPhone && !(contactMobile && contactToDisplay?.ContactMethodName !== 'TELEFON')) {
            <a
              [class.preffered]="contactToDisplay?.ContactMethodName === 'TELEFON'"
              href="tel: {{ contactPhone }}"
              >
              <img alt="email" src="assets/icons/mobile-phone.svg">
            </a>
          }

          @if (!hasNoEmail && !contactToDisplay?.Anonymized) {
            <a
              [class.preffered]="contactToDisplay?.ContactMethodName === 'E-MAIL'"
              href="mailto: {{ user?.Login?.endsWith('@finstral.cloud') ? contactToDisplay?.Email : (contactEmailData | async) }}"
              >
              <img alt="email" src="assets/icons/mobile-email.svg">
            </a>
          }

          <a href="javascript:void(0)" (click)="expandForMobile = !expandForMobile">
            <img
              class="arrow"
              [class.open]="expandForMobile"
              src="/assets/icons/arrow-up.svg"
              alt="Arrow"
              >
            </a>
          </div>

          <div class="section-text enquiries" fiTranslation="REQUEST_OVERVIEW_FILTER_HEADLINE_REQUEST"></div>
          <div class="pair">
            <fi-input
              type="SELECT"
              (onChange)="onTabChanged.emit(+$event)"
              [options]="getEnquiries()"
              [enableSearch]="true"
              [notifyAboutUnsavedChanges]="false"
              [namePropertyPath]="getItemText"
              [valuePropertyPath]="'tabIndex'"
              [selectedOptionsOrValues]="selectedTabIndex"
            ></fi-input>

            @if (showAddEnquiry) {
              <button class="add-btn" (click)="onNewLeadCreate.emit(selectedLeadDetails?.Lead?.Contact)">
                <mat-icon>
                  add
                </mat-icon>
              </button>
            }
          </div>

        </div>

        <div class="hide-on-mobile" [class.show]="expandForMobile">
          <div class="tabs-container">
            <div class="section-text enquiries" fiTranslation="REQUEST_OVERVIEW_FILTER_HEADLINE_REQUEST"></div>
            <div class="tabs-container-inner">
              @for (lead of getEnquiries(); track lead; let i = $index) {
                @if (selectedLinkedContactId && i === selectedTabIndex || !selectedLinkedContactId) {
                  <button class="tab {{lead.class}}"
                    [style]="lead.style"
                    [class.relationship]="lead.LeadTypeId === leadTypeRelationshipManagement"
                    [class.selected]="selectedLinkedContactId && i === selectedTabIndex || i === selectedTabIndex"
                    [class.brokering-parent]="lead.Id === brokeringParentLeadId && lead.Id !== selectedLeadId"
                    [class.with-icon]="selectedLinkedContactId && i === selectedTabIndex || lead.isBrokeredLead" (click)="onTabChanged.emit(i)">
                    @if (lead.isBrokeredLead) {
                      <img #brokeringIcon class="brokered-lead-icon"
                        fiTranslation="REQUEST_DETAIL_CONTACT_BROKERED_ENQUIRIES_TOOLTIP"  [isTitle]="true"
                        matTooltip="{{ brokeringIcon.dataset.matTooltip }}" matTooltipPosition="below"
                        matTooltipClass='tooltip-style' alt="" src="assets/icons/new/double-arrow.svg">
                      }
                      {{ lead.LeadTypeId === leadTypeRelationshipManagement ? lead.LeadTypeText : lead.DateFormattedId }}
                      @if (selectedLinkedContactId && i === selectedTabIndex) {
                        <img class="link-icon" alt="icon"
                          src="assets/icons/link-horizontal-1.svg">
                        }
                      </button>
                    }
                  }

                  @if (!selectedLinkedContactId) {
                    @if (showLoadClosedLeads) {
                      <button class="tab completed" fiTranslation="REQUEST_DETAIL_DONE_LEAD" style="order: 20000"
                        (click)="onTabChanged.emit(nextToLastLeadIndex)">
                      </button>
                    }
                  }

                  @if (!selectedLinkedContactId && brokeringSourceLead) {
                    <button class="tab is-opened"
                      [class.brokering-parent]="brokeringSourceLead.Id !== selectedLeadId"
                      [style]="setLeadOrderStyle(brokeringSourceLead)"
                      [class.relationship]="brokeringSourceLead.LeadTypeId === leadTypeRelationshipManagement"
                      [class.selected]="brokeringSourceLead.Id === selectedLeadId"
                      (click)="onBrokeredTabSelected.emit(brokeringSourceLead)">
                      {{ brokeringSourceLead.LeadTypeId === leadTypeRelationshipManagement ? brokeringSourceLead.LeadTypeText : brokeringSourceLead.DateFormattedId }}
                    </button>
                  }

                  @if (!selectedLinkedContactId) {
                    @for (lead of brokeredLeads; track trackByLeadId($index, lead)) {
                      <button class="tab is-opened with-icon"
                        [style]="setLeadOrderStyle(lead)"
                        [class.relationship]="lead.LeadTypeId === leadTypeRelationshipManagement"
                        [class.selected]="lead.Id === selectedLeadId"
                        (click)="onBrokeredTabSelected.emit(lead)">
                        <img #brokeringIcon class="brokered-lead-icon"
                          fiTranslation="REQUEST_DETAIL_CONTACT_BROKERED_ENQUIRIES_TOOLTIP" [isTitle]="true"
                          matTooltip="{{ brokeringIcon.dataset.matTooltip }}" matTooltipPosition="below"
                          matTooltipClass='tooltip-style' alt="" src="assets/icons/new/double-arrow.svg">
                          {{ lead.LeadTypeId === leadTypeRelationshipManagement ? lead.LeadTypeText : lead.DateFormattedId }}
                        </button>
                      }
                    }
                  </div>

                  @if (showAddEnquiry) {
                    <button class="add-btn line-button bold" (click)="onNewLeadCreate.emit(selectedLeadDetails?.Lead?.Contact)">
                      <mat-icon>add</mat-icon> <span fiTranslation="REQUEST_DETAIL_CONTACT_ADD_NEW_ENQUIRY"></span>
                    </button>
                  }
                </div>

                @if (!contactToDisplay?.Anonymized) {
                  <div class="section-text contact" fiTranslation="REQUEST_DETAIL_HEADLINE_CONTACT"></div>
                  <div class="contact-line-with-copy">
                    <a class="contact-line ellipsis has-preferred bold"
                      href="mailto: {{ user?.Login?.endsWith('@finstral.cloud') ? contactToDisplay?.Email : (contactEmailData | async) }}">
                      <span class="text">{{ contactToDisplay?.Email }}</span>
                      @if (contactToDisplay?.ContactMethodName === 'E-MAIL') {
                        <span class="prefer" [fiTranslation]="'REQUEST_DETAIL_HEADLINE_PREFERENCE'"></span>
                      }
                    </a>
                    @if (contactToDisplay?.Email) {
                      <fi-copy-clipboard [small]="true" [copyText]="contactToDisplay?.Email"></fi-copy-clipboard>
                    }
                  </div>
                  @if (contactToDisplay?.AdditionalEmail) {
                    <div class="contact-line-with-copy">
                      <a class="contact-line ellipsis bold"
                        href="mailto: {{ user?.Login?.endsWith('@finstral.cloud') ? contactToDisplay?.AdditionalEmail : (contactAdditionalEmailData | async) }}">
                        <span class="text">{{ contactToDisplay?.AdditionalEmail }}</span>
                      </a>
                      @if (contactToDisplay?.AdditionalEmail) {
                        <fi-copy-clipboard [small]="true" [copyText]="contactToDisplay?.AdditionalEmail"></fi-copy-clipboard>
                      }
                    </div>
                  }
                  @if (contactPhone; as phone) {
                    <div class="contact-line-with-copy">
                      <a class="contact-line ellipsis has-preferred bold"
                        href="tel: {{ phone }}">
                        <span class="text">{{ phone }}</span>
                        @if (contactToDisplay?.ContactMethodName === 'TELEFON') {
                          <span class="prefer"
                          [fiTranslation]="'REQUEST_DETAIL_HEADLINE_PREFERENCE'"></span>
                        }
                      </a>
                      <fi-copy-clipboard [small]="true" [copyText]="phone"></fi-copy-clipboard>
                    </div>
                  }
                  @if (contactMobile; as phone) {
                    <div class="contact-line-with-copy">
                      <a class="contact-line ellipsis has-preferred bold"
                        href="tel: {{ phone }}">
                        <span class="text">{{ phone }}</span>
                        @if (contactToDisplay?.ContactMethodName === 'MOBILE') {
                          <span class="prefer"
                          [fiTranslation]="'REQUEST_DETAIL_HEADLINE_PREFERENCE'"></span>
                        }
                      </a>
                      <fi-copy-clipboard [small]="true" [copyText]="phone"></fi-copy-clipboard>
                    </div>
                  }
                  @if (contactAdditionalMobile; as phone) {
                    <div class="contact-line-with-copy">
                      <a class="contact-line ellipsis bold"
                        href="tel: {{ phone }}">
                        <span class="text">{{ phone }}</span>
                      </a>
                      <fi-copy-clipboard [small]="true" [copyText]="phone"></fi-copy-clipboard>
                    </div>
                  }
                  @if (compendiumVisible) {
                    <div class="section-text compendium" fiTranslation="REQUEST_DETAIL_COMPENDIUM_HEADLINE"></div>
                    <div class="contact-line compendium">
                      <img alt="Check"
                        [src]="leadCompendiumHasAccess ? 'assets/icons/consent-agree-checkbox.svg' : 'assets/icons/consent-disagree-checkbox.svg'">
                        <span [fiTranslation]="leadCompendiumHasAccess ? 'REQUEST_DETAIL_COMPENDIUM_HAS_ACESS' : 'REQUEST_DETAIL_COMPENDIUM_NO_ACESS'"></span>
                      </div>
                    }
                    @if (contactToDisplay?.Company) {
                      <div class="connected-company-contact-list">
                        <div class="section-text contact">
                          <span [fiTranslation]="'REQUEST_DETAIL_CONTACT_OHTER_COMPANY_CONTACTS'"></span>&nbsp;{{ contactToDisplay?.Company }}
                        </div>
                        @if (companyContacts?.length) {
                          <div class="contact-line bold">
                            @for (contact of companyContacts; track contact) {
                              <span class="pointer" (click)="openLeadDetail(contact, $event.ctrlKey)">
                                {{ contact.FirstName }} {{ contact.LastName }} <br/>
                              </span>
                            }
                          </div>
                        }
                        <button class="add-btn line-button bold" (click)="addAdditionalContact()">
                          <mat-icon>add</mat-icon>
                          <span [fiTranslation]="'REQUEST_DETAIL_CONTACT_ADD_COMPANY_CONTACT'"></span>
                        </button>
                      </div>
                    }
                  }

                  <div class="section-text language" fiTranslation="FORM_HEADLINE_LANGUAGE"></div>
                  @if (contactToDisplay?.LanguageText) {
                    <div class="contact-line">
                      {{ contactToDisplay?.LanguageText }}
                    </div>
                  }

                  <div class="section-text address" fiTranslation="REQUEST_DETAIL_HEADLINE_ADDRESS"></div>
                  @if (!hasNoAddress) {
                    <div class="contact-line-with-copy align-top">
                      <a (click)="openMapNewTab()" href="javascript:void(0)" class="contact-line address">
                        @if (contactToDisplay?.Address) {
                          <span>{{ contactToDisplay?.Address }}</span>
                        }
                        @if (contactToDisplay?.AddressExt) {
                          <span>{{ contactToDisplay?.AddressExt }}</span>
                        }
                        @if (contactToDisplay?.ZipCode || contactToDisplay?.City || contactToDisplay?.ProvinceText) {
                          <span>
                            {{ contactToDisplay?.ZipCode }} {{ contactToDisplay?.City }} {{ contactToDisplay?.ProvinceText ? '(' + contactToDisplay?.ProvinceText + ')' : '' }}
                          </span>
                        }
                        @if (contactToDisplay?.CountryText) {
                          <span>{{ contactToDisplay?.CountryText }}</span>
                        }
                      </a>
                      <fi-copy-clipboard
                        [small]="true"
          [copyText]="
            (contactToDisplay?.Address || '') +
            (contactToDisplay?.ZipCode || contactToDisplay?.City ? ', ' : '') +
            (
              (contactToDisplay?.ZipCode || '') +
              (contactToDisplay?.ZipCode && contactToDisplay?.City ? ' ' : '') +
              (contactToDisplay?.City || '')
            ) +
            (contactToDisplay?.ProvinceText ? ', ' + contactToDisplay.ProvinceText : '') +
            (contactToDisplay?.CountryText ? ', ' + contactToDisplay.CountryText : '')
          "
                      ></fi-copy-clipboard>
                    </div>
                  }


                  @if (contactToDisplay?.VatNumber && !contactToDisplay?.Anonymized) {
                    <div class="contact-line address">
                      {{ contactToDisplay?.VatNumber }}
                    </div>
                  }

                  @if (contactToDisplay?.Website) {
                    <div class="section-text website" fiTranslation="REQUEST_DETAIL_CONTACT_HEADLINE_WEBSITE"></div>
                    <a href="{{getWebsiteUrl(contactToDisplay?.Website)}}" target="_blank" class="contact-line address">
                      {{ contactToDisplay?.Website }}
                    </a>
                  }

                  @if (hasNoAddress) {
                    <div class="contact-line address"> -</div>
                  }

                  @if (contactToDisplay?.TaxNumber && !contactToDisplay?.Anonymized) {
                    <div class="section-text address" fiTranslation="REQUEST_CREATE_CONTACT_TAX_NUMBER"></div>
                    <div class="contact-line address">
                      {{ contactToDisplay?.TaxNumber }}
                    </div>
                  }

                  <div class="consent-container">
                    <a class="contact-line consent" href="javascript:void(0)" (click)="scrollToHistoryStart()">
                      <img alt="Check" src="assets/icons/consent-agree-checkbox.svg">
                      <span fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_PRIVACY"></span>
                    </a>

                    <a class="contact-line consent" href="javascript:void(0)"
                      (click)="scrollToHistoryStart('secondHistoryComment')">
                      <img alt="Check"
                        [src]="contactToDisplay?.ConsentMarketing ? 'assets/icons/consent-agree-checkbox.svg' : 'assets/icons/consent-disagree-checkbox.svg'">
                        <span fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING"></span>
                      </a>

                      <a class="contact-line consent" href="javascript:void(0)" (click)="scrollToHistoryStart('thirdHistoryComment')">
                        <img alt="Check"
                          [src]="contactToDisplay?.ConsentThirdParties ? 'assets/icons/consent-agree-checkbox.svg' : 'assets/icons/consent-disagree-checkbox.svg'">
                          <span fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING_THIRD_PARTIES"></span>
                        </a>
                      </div>

                      <div class="section-text files" fiTranslation="REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_SUMMARY_1"></div>

                      <a class="contact-line files bold" href="javascript:void(0)" (click)="onAttachmentsPopupOpen()">
                        <span fiTranslation="REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_SUMMARY_1"></span>
                      </a>

                      <div class="separator"></div>

                      @if (selectedLeadDetails?.Creator) {
                        <div class="section-text created" fiTranslation="REQUEST_DETAIL_HEADLINE_CREATE"></div>
                        <div class="creator-container">
                          @if (!!selectedLeadDetails.Creator.AvatarURL) {
                            <img [src]="selectedLeadDetails.Creator.AvatarURL"
                              alt="Contact image">
                          }
                          <div class="creator-lines">
                            <div
                              class="contact-line">{{ selectedLeadDetails.Creator.FirstName + ' ' + selectedLeadDetails.Creator.LastName }}
                            </div>
                            <div class="contact-line">
                              {{ dateTimeHelper.getFormattedDate(selectedLeadDetails.Lead?.CreTS) }}
                              @if (getLanguage() !== 'it') {
                                <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME"></span>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
